module.exports = __webpack_public_path__ + "fonts/Sailec-Medium.e9f1335a.woff";